export const MFA_SESSION_SCANS_COLUMN_WIDTHS = {
	SCREENSHOT: '182px',
	SCAN_NAME: '180px',
	METRIC: '120px',
	ELEMENTS_WITH_ISSUES: '170px'
} as const;
